"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prepareLastActivityDate = void 0;
var _formatDateLong = require("../../../utils/formatDateLong");
const prepareLastActivityDate = lastActivityDate => {
  if (!lastActivityDate) {
    return;
  }
  return (0, _formatDateLong.formatDateLong)(new Date(lastActivityDate));
};
exports.prepareLastActivityDate = prepareLastActivityDate;